export const TRANSLATION = 'builder.dashboard.progress_tracker.widgets'
